export const Timezones = {
  "(GMT-11:00) Pago Pago": "PP-11,-11,Pacific/Pago_Pago",
  "(GMT-10:00) Hawaii Time": "HT-10,-10,Pacific/Honolulu",
  "(GMT-08:00) Pacific Time": "PT-8,-8,America/Los_Angeles",
  "(GMT-08:00) Pacific Time - Tijuana": "PTT-8,-8,America/Tijuana",
  "(GMT-07:00) Mountain Time": "MT-7,-7,America/Denver",
  "(GMT-07:00) Mountain Time - Arizona": "MTA-7,-7,America/Phoenix",
  "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan":
    "MTC-7,-7,America/Mazatlan",
  "(GMT-06:00) Central Time": "CT-6,-6,America/Chicago",
  "(GMT-06:00) Central Time - Mexico City": "CTM-6,-6,America/Mexico_City",
  "(GMT-06:00) Central Time - Regina": "CTR-6,-6,America/Regina",
  "(GMT-06:00) Guatemala": "GTM-6,-6,America/Guatemala",
  "(GMT-05:00) Eastern Time": "ET-5,-5,America/New_York",
  "(GMT-05:00) Lima": "LA-5,-5,America/Lima",
  "(GMT-04:30) Caracas": "CS-4.5,-4.5,America/Caracas",
  "(GMT-04:00) Atlantic Time - Halifax": "ATH-4,-4,America/Halifax",
  "(GMT-04:00) Guyana": "GA-4,-4,America/Guyana",
  "(GMT-04:00) La Paz": "LP-4,-4,America/La_Paz",
  "(GMT-03:30) Newfoundland Time - St. Johns": "NT-3.5,-3.5,America/St_Johns",
  "(GMT-03:00) Buenos Aires": "BA-3,-3,America/Argentina/Buenos_Aires",
  "(GMT-03:00) Godthab": "GB-3,-3,America/Godthab",
  "(GMT-03:00) Montevideo": "MV-3,-3,America/Montevideo",
  "(GMT-03:00) Santiago": "SO-3,-3,America/Santiago",
  "(GMT-03:00) Sao Paulo": "SP-3,-3,America/Sao_Paulo",
  "(GMT-02:00) South Georgia": "SG-2,-2,Atlantic/South_Georgia",
  "(GMT-01:00) Azores": "AS-1,-1,Atlantic/Azores",
  "(GMT-01:00) Cape Verde": "CV-1,-1,Atlantic/Cape_Verde",
  "(GMT+00:00) Casablanca": "CA,0,Africa/Casablanca",
  "(GMT+00:00) Dublin": "DUB,0,Europe/Dublin",
  "(GMT+00:00) Lisbon": "LIS,0,Europe/Lisbon",
  "(GMT+00:00) London": "LON,0,Europe/London",
  "(GMT+00:00) Monrovia": "MON,0,Africa/Monrovia",
  "(GMT+01:00) Algiers": "ALG+1,1,Africa/Algiers",
  "(GMT+01:00) Amsterdam": "AMS+1,1,Europe/Amsterdam",
  "(GMT+01:00) Berlin": "BER+1,1,Europe/Berlin",
  "(GMT+01:00) Brussels": "BRU+1,1,Europe/Brussels",
  "(GMT+01:00) Budapest": "BUD+1,1,Europe/Budapest",
  "(GMT+01:00) Central European Time - Belgrade": "CETB+1,1,Europe/Belgrade",
  "(GMT+01:00) Central European Time - Prague": "CETP+1,1,Europe/Prague",
  "(GMT+01:00) Copenhagen": "COP+1,1,Europe/Copenhagen",
  "(GMT+01:00) Madrid": "MAD+1,1,Europe/Madrid",
  "(GMT+01:00) Paris": "PAR+1,1,Europe/Paris",
  "(GMT+01:00) Rome": "ROM+1,1,Europe/Rome",
  "(GMT+01:00) Stockholm": "STO+1,1,Europe/Stockholm",
  "(GMT+01:00) Vienna": "VIE+1,1,Europe/Vienna",
  "(GMT+01:00) Warsaw": "WAR+1,1,Europe/Warsaw",
  "(GMT+02:00) Athens": "ATH+2,2,Europe/Athens",
  "(GMT+02:00) Bucharest": "BUC+2,2,Europe/Bucharest",
  "(GMT+02:00) Cairo": "CAI+2,2,Africa/Cairo",
  "(GMT+02:00) Jerusalem": "JER+2,2,Asia/Jerusalem",
  "(GMT+02:00) Johannesburg": "JOH+2,2,Africa/Johannesburg",
  "(GMT+02:00) Helsinki": "HEL+2,2,Europe/Helsinki",
  "(GMT+02:00) Kiev": "KIE+2,2,Europe/Kiev",
  "(GMT+02:00) Moscow-01 - Kaliningrad": "KAL+2,2,Europe/Kaliningrad",
  "(GMT+02:00) Riga": "RIG+2,2,Europe/Riga",
  "(GMT+02:00) Sofia": "SOF+2,2,Europe/Sofia",
  "(GMT+02:00) Tallinn": "TAL+2,2,Europe/Tallinn",
  "(GMT+02:00) Vilnius": "VIL+2,2,Europe/Vilnius",
  "(GMT+03:00) Istanbul": "IST+3,3,Europe/Istanbul",
  "(GMT+03:00) Baghdad": "BAG+3,3,Asia/Baghdad",
  "(GMT+03:00) Nairobi": "NAI+3,3,Africa/Nairobi",
  "(GMT+03:00) Minsk": "MIN+3,3,Europe/Minsk",
  "(GMT+03:00) Riyadh": "RIY+3,3,Asia/Riyadh",
  "(GMT+03:00) Moscow+00 - Moscow": "MOS+3,3,Europe/Moscow",
  "(GMT+03:30) Tehran": "TEH+3.5,3.5,Asia/Tehran",
  "(GMT+04:00) Baku": "BAK+4,4,Asia/Baku",
  "(GMT+04:00) Moscow+01 - Samara": "SAM+4,4,Europe/Samara",
  "(GMT+04:00) Tbilisi": "TBI+4,4,Asia/Tbilisi",
  "(GMT+04:00) Yerevan": "YER+4,4,Asia/Yerevan",
  "(GMT+04:30) Kabul": "KAB+4.5,4.5,Asia/Kabul",
  "(GMT+05:00) Karachi": "KAR+5,5,Asia/Karachi",
  "(GMT+05:00) Moscow+02 - Yekaterinburg": "YEK+5,5,Asia/Yekaterinburg",
  "(GMT+05:00) Tashkent": "TAS+5,5,Asia/Tashkent",
  "(GMT+05:30) Colombo": "COL+5.5,5.5,Asia/Colombo",
  "(GMT+06:00) Almaty": "ALM+6,6,Asia/Almaty",
  "(GMT+06:00) Dhaka": "DHA+6,6,sia/Dhaka",
  "(GMT+06:30) Rangoon": "RAN+6.5,6.5,Asia/Rangoon",
  "(GMT+07:00) Bangkok": "BAN+7,7,Asia/Bangkok",
  "(GMT+07:00) Jakarta": "JAK+7,7,Asia/Jakarta",
  "(GMT+07:00) Moscow+04 - Krasnoyarsk": "KRA+7,7,Asia/Krasnoyarsk",
  "(GMT+08:00) China Time - Beijing": "BEI+8,8,Asia/Shanghai",
  "(GMT+08:00) Hong Kong": "HON+8,8,Asia/Hong_Kong",
  "(GMT+08:00) Kuala Lumpur": "KUA+8,8,Asia/Kuala_Lumpur",
  "(GMT+08:00) Moscow+05 - Irkutsk": "IRK+8,8,Asia/Irkutsk",
  "(GMT+08:00) Singapore": "SIN+8,8,Asia/Singapore",
  "(GMT+08:00) Taipei": "TAI+8,8,Asia/Taipei",
  "(GMT+08:00) Ulaanbaatar": "ULA+8,8,Asia/Ulaanbaatar",
  "(GMT+08:00) Western Time - Perth": "PER+8,8,Australia/Perth",
  "(GMT+09:00) Moscow+06 - Yakutsk": "YAK+9,9,Asia/Yakutsk",
  "(GMT+09:00) Seoul": "SEO+9,9,Asia/Seoul",
  "(GMT+09:00) Tokyo": "TOK+9,9,Asia/Tokyo",
  "(GMT+09:30) Central Time - Darwin": "DAR+9.5,9.5,Australia/Darwin",
  "(GMT+10:00) Eastern Time - Brisbane": "BRI+10,10,Australia/Brisbane",
  "(GMT+10:00) Guam": "GUA+10,10,Pacific/Guam",
  "(GMT+10:00) Moscow+07 - Magadan": "MAG+10,10,Asia/Magadan",
  "(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk": "YUZ+10,10,Asia/Vladivostok",
  "(GMT+10:00) Port Moresby": "POR+10,10,Pacific/Port_Moresby",
  "(GMT+10:30) Central Time - Adelaide": "ADE+10.5,10.5,Australia/Adelaide",
  "(GMT+11:00) Eastern Time - Hobart": "HOB+11,11,Australia/Hobart",
  "(GMT+11:00) Eastern Time - Melbourne, Sydney": "MEL+11,11,Australia/Sydney",
  "(GMT+11:00) Guadalcanal": "GUA+11,11,Pacific/Guadalcanal",
  "(GMT+11:00) Noumea": "NOU+11,11,Pacific/Noumea",
  "(GMT+12:00) Majuro": "MAH+12,12,Pacific/Majuro",
  "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy":
    "PET+12,12,Asia/Kamchatka",
  "(GMT+13:00) Auckland": "AUC+13,13,Pacific/Auckland",
  "(GMT+13:00) Fakaofo": "FAK+13,13,Pacific/Fakaofo",
  "(GMT+13:00) Fiji": "FIJ+13,13,Pacific/Fiji",
  "(GMT+13:00) Tongatapu": "TON+13,13,Pacific/Tongatapu",
  "(GMT+14:00) Apia": "API+14,14,Pacific/Apia",
};
